import React, { Component } from 'react';
//import logo from './images/logo.svg';
import home_bg_crop from './../images/home_bg_crop.jpg';
import './../css/App.css';
import InfoTile from './../js/InfoTile'

class App extends Component {
  render() {
    return (
      <div className="splash">
        <div className="splash-content">
        </div>
        <div className="splash-image">
            <img src={home_bg_crop} alt="splash" />
        </div>
      </div>
    );
  }
}

export default App;



// WEBPACK FOOTER //
// ./src/js/App.js